import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { ProductLineZodSchema } from "./useProductLines";

interface UseGetOneProductLineOptions {
    productLineId?: string | number;
    enabled?: boolean;
}

export const useGetOneProductLine = (options: UseGetOneProductLineOptions) => {
    const { productLineId, enabled = true } = options;

    const query = useQuery({
        queryKey: ["oneProductLine", productLineId],
        queryFn: async () => {
            if (!productLineId) {
                throw new Error("Product line ID is required");
            }

            const response = await loggedInApiCall.get(`/api/product_lines/${productLineId}`);
            return zodParseWithLog(response.data, ProductLineZodSchema, "oneProductLine");
        },
        enabled: enabled && !!productLineId,
    });

    return {
        productLine: query.data,
        isFetched: query.isFetched,
        isLoading: query.isLoading,
        error: query.error,
    };
};
